import * as React from 'react'
import { Table, Input, Col } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import { observer } from 'mobx-react'
import { ButtonGroup } from '../../../../components/Button/ButtonGroup'
import { IntegrationLocAPIKey, IntegrationStore, Integrators } from '../IntegrationStore'

interface Props<T extends Integrators> {
  integrationStore: IntegrationStore<T>
  onItemSave: (locationItem: IntegrationLocAPIKey<T>) => void
  onInputChange: (location: IntegrationLocAPIKey<T>, value: string) => void
  description?: JSX.Element | undefined
  apiKeyTitle?: string
}

interface ILocationApiTableRecord {
  key: number
  locationName: string
  apiKey: JSX.Element | null
  buttonGroup: JSX.Element | undefined
}

@observer
export class IntegrationApiSettings<T extends Integrators> extends React.Component<Props<T>> {
  onCancel = (locationItem: IntegrationLocAPIKey<T>) => {
    locationItem.setIsEditable(false)
    locationItem.setUpdatedApiKey(locationItem.apiKey)
  }

  get columns(): ColumnProps<ILocationApiTableRecord>[] {
    return [
      {
        title: 'Location',
        dataIndex: 'locationName',
        width: 150,
      },
      {
        title: this.props.apiKeyTitle ? this.props.apiKeyTitle : 'API key',
        dataIndex: 'apiKey',
      },
      {
        title: '',
        dataIndex: 'buttonGroup',
        width: 80,
        fixed: 'right',
        align: 'center',
      },
    ]
  }

  get dataSource(): ILocationApiTableRecord[] {
    const locations: IntegrationLocAPIKey<Integrators>[] =
      this.props.integrationStore.locationApiKeys

    return locations.map((loc): ILocationApiTableRecord => {
      return {
        key: loc.location.id,
        locationName: loc.location.name,
        apiKey: loc.isEditable ? (
          <Input
            allowClear
            value={loc.updatedApiKey || undefined}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              this.props.onInputChange(loc, e.target.value)
            }
          />
        ) : (
          <div>{loc.updatedApiKey}</div>
        ),
        buttonGroup: (
          <ButtonGroup
            canSave={loc.canSave}
            editable={loc.isEditable}
            isUpdating={loc.isUpdating}
            onSave={() => this.props.onItemSave(loc)}
            onEdit={() => loc.setIsEditable(true)}
            onCancel={() => this.onCancel(loc)}
          />
        ),
      }
    })
  }

  render() {
    return (
      <div>
        {this.props.description}
        <Table
          rowClassName={() => 'background-white editable-row integration-api-settings'}
          pagination={false}
          columns={this.columns}
          dataSource={this.dataSource}
          scroll={{ x: true }}
        />
      </div>
    )
  }
}
